export function chunkString(str, length, splitAtSpaces = false) {
    if (splitAtSpaces && str.split(" ").length > 1) {
        const words = str.split(" ");
        const result = [];
        let currentChunk = words[0];
        for (const word of words.slice(1)) {
            if ((currentChunk + word + 1).length > length) {
                result.push(currentChunk.trim());
                currentChunk = word;
            }
            else {
                currentChunk += ` ${word}`;
            }
        }
        if (currentChunk.trim().length > 0) {
            result.push(currentChunk.trim());
        }
        return result;
    }
    return length > 0 ? (str.match(new RegExp(`.{1,${length}}`, "g")) ?? [""]) : [str];
}
export function chunkRows(str, width) {
    if (str.length <= width) {
        return [str];
    }
    const rows = [];
    const list = str.split(" ");
    for (let i = 0; i < list.length; i++) {
        const s = list[i];
        let lastRow = rows.at(-1);
        if (!lastRow) {
            if (s.length > width) {
                rows.push(...chunkString(s, width));
                rows[rows.length - 1] = `${rows[rows.length - 1]} `;
            }
            else {
                rows.push(`${s} `);
            }
            continue;
        }
        // if s fits in the current row
        if (lastRow.length + s.length + 1 <= width) {
            rows[rows.length - 1] += s;
        }
        else {
            // if s doesn't fit in the current row
            // wrap by dots
            const t = s.split(".");
            for (let j = 0; j < t.length; j++) {
                lastRow = rows.at(-1);
                const elem = t[j];
                if (lastRow.length + elem.length + 2 < width) {
                    rows[rows.length - 1] += (j > 0 ? "." : "") + elem;
                }
                else {
                    const stringToPush = (j > 0 ? "." : "") + elem;
                    if (stringToPush.length <= width) {
                        rows.push(stringToPush);
                    }
                    else {
                        rows.push(...chunkString(stringToPush, width));
                    }
                }
            }
        }
        if (i < list.length - 1) {
            rows[rows.length - 1] += " ";
        }
    }
    return rows;
}
//# sourceMappingURL=chunkString.js.map